// @ts-nocheck

import { FC, memo, useEffect } from "react";
import Styles from "./styles";
import defaultBG from "./assets/default";
import upBG from "./assets/up";
import rightBG from "./assets/right";
import leftBG from "./assets/left";
import downBG from "./assets/down";
import okBG from "./assets/ok";
import fixRatio from "src/utils/fixRatio";
import get from "lodash/get";
import { useLocation, useHistory } from "react-router-dom";

let selectableRows:
  | string
  | any[]
  | Iterable<unknown>
  | ArrayLike<unknown>
  | null = null;
let listContainerELement: Element | null = null;
let videoItemMarginRight: number | null = null;
let videoItemWidth: number | null = null;
let videoListHeight: number | null = null;
let tagItemMargin: number | null = null;
let tagItemWidth: string | number | null = null;
let tagListHeight: number | null = null;
let interviewWrapper: Element | null = null;
let interviewHeight: string | null = null;
let videoLists: string | any[] | Iterable<unknown> | ArrayLike<unknown> | null =
  null;
let tagLists: string | any[] | Iterable<unknown> | ArrayLike<unknown> | null =
  null;
let paginationWrapper: Element | null = null;

const Controls = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    fixRatio(checkRenderedDom);
    let canChangeScroll = true;

    const handleKeydown = (event: KeyboardEvent) => {
      switch (event.keyCode) {
        case 38: // Arrow Up
          event.preventDefault();
          verticalMove("up");
          break;
        case 40: // Arrow Down
          event.preventDefault();
          verticalMove("down");
          break;
        case 37: // Arrow Left
          event.preventDefault();
          horizontalMove("left");
          break;
        case 39: // Arrow Right
          event.preventDefault();
          horizontalMove("right");
          break;
        case 13: // Enter
          event.preventDefault();
          handleClickActiveItem();
          break;
        case 461: // Back
          event.preventDefault();
          if (
            get(window, ["webOS", "platform", "tv"]) &&
            get(window, ["location", "pathname"], "") === "/" &&
            !get(window, ["location", "search"])
          ) {
            //@ts-ignore
            window.webOS.platformBack();
          } else {
            history.goBack();
          }
          break;
        default:
          break;
      }
    };

    const handleWheel = (data: WheelEvent) => {
      if (canChangeScroll) {
        if (data.deltaY < -10) {
          verticalMove("down");
        } else if (data.deltaY > 10) {
          verticalMove("up");
        }
        canChangeScroll = false;
        setTimeout(() => {
          canChangeScroll = true;
        }, 200);
      }
    };

    window.addEventListener("keydown", handleKeydown);
    window.addEventListener("wheel", handleWheel);

    return () => {
      window.removeEventListener("keydown", handleKeydown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      checkHaveActiveItem();
    }, 100);
  }, [location.pathname]);

  const checkElementHasClass = (element: any, className: string): boolean => {
    return (
      ` ${element.className} `
        .replace(/[\n\t]/g, " ")
        .indexOf(` ${className} `) > -1
    );
  };

  const checkRenderedDom = () => {
    let interval: string | number | NodeJS.Timeout | null | undefined = null;

    function handleCheckRenderedDom() {
      const videoListsItems = document.getElementsByClassName("videoList");
      const videoItems = document.getElementsByClassName("videoItem");
      const tagListsItems = document.getElementsByClassName("tagList");
      const tagItems = document.getElementsByClassName("tagItem");
      const interviewWrapperElement =
        document.getElementsByClassName("interviewWrapper");
      const paginationWrapperElement =
        document.getElementsByClassName("paginationWrapper")[0];
      let videoItemMarginRightValue = 0;
      Array.from(videoItems).forEach((item: any) => {
        if (
          videoItemMarginRightValue < 1 &&
          parseInt(window.getComputedStyle(item).marginRight, 10) > 0
        ) {
          videoItemMarginRight = parseInt(
            window.getComputedStyle(item).marginRight,
            10
          );
        }
      });
      if (videoItems.length > 0) {
        selectableRows = document.getElementsByClassName("selectableRow");
        videoItemMarginRight = videoItemMarginRightValue;
        videoItemWidth = parseInt(
          window.getComputedStyle(videoItems[0]).width,
          10
        );
        videoListHeight = parseInt(
          window.getComputedStyle(videoListsItems[0]).height,
          10
        );
        tagItemMargin =
          tagItems.length > 1
            ? parseInt(window.getComputedStyle(tagItems[1]).marginRight, 10) +
              parseInt(window.getComputedStyle(tagItems[1]).marginLeft, 10)
            : null;
        tagItemWidth =
          tagItems.length > 0
            ? parseInt(window.getComputedStyle(tagItems[0]).width, 10)
            : null;
        tagListHeight =
          tagListsItems.length > 0
            ? parseInt(window.getComputedStyle(tagListsItems[0]).height, 10)
            : null;
        listContainerELement =
          document.getElementsByClassName("listsContainer")[0];
        interviewWrapper =
          interviewWrapperElement.length > 0
            ? interviewWrapperElement[0]
            : null;
        interviewHeight =
          interviewWrapperElement.length > 0
            ? window.getComputedStyle(interviewWrapperElement[0]).height
            : "0px";
        videoLists = videoListsItems;
        tagLists = tagListsItems;
        paginationWrapper = paginationWrapperElement;
        setTimeout(() => {
          if (interval) {
            clearInterval(interval);
          }
          document.getElementsByClassName("listsContainer")[0].style.marginTop =
            "0px";
        }, 100);
      }
    }

    interval = setInterval(handleCheckRenderedDom, 500);
    checkHaveActiveItem();
  };

  const checkHaveActiveItem = (): boolean => {
    selectableRows = document.getElementsByClassName("selectableRow");
    const selectableRowsGroup =
      document.getElementsByClassName("selectableRow");

    const lastActive = document.getElementsByClassName("lastActive")[0];
    if (!selectableRows) {
      selectableRows = Array.from(selectableRowsGroup);
    }
    if (selectableRowsGroup.length > 0) {
      if (lastActive) {
        lastActive.classList.remove("lastActive", "activeItem");
      }
      selectableRowsGroup?.[0]?.classList?.add("activeRow");
      selectableRowsGroup?.[0]
        ?.getElementsByClassName("selectableItem")?.[0]
        ?.classList.add("activeItem", "lastActive");
    }
    return false;
  };

  // eslint-disable-next-line
  const handleClickActiveItem = () => {
    const activeElement = document.getElementsByClassName("activeItem")[0];
    if (
      activeElement &&
      !checkElementHasClass(activeElement, "disableSelection")
    ) {
      const route = activeElement.getAttribute("route");
      const isSeries = activeElement.getAttribute("isseries");
      const clickable = activeElement.getAttribute("clickable");
      activeElement.click();
      if (clickable) {
        activeElement.click();
      }
      if (route && route !== location.pathname) {
        navigate(route, { state: { isSeries } });
      }
    }
  };

  // eslint-disable-next-line
  const verticalMove = (direction: string): void => {
    let canChangeActiveRow = true;

    let hasActiveRow = false;
    if (selectableRows && selectableRows.length >= 1) {
      function removeActiveItem(element: any) {
        element.classList.remove("activeRow");
        Array.from(element.getElementsByClassName("selectableItem")).forEach(
          (item: any) => {
            if (checkElementHasClass(item, "activeItem")) {
              item.classList.remove("activeItem");
            }
          }
        );
      }

      function handleSetActiveItemAfterActiveRowChanged(
        i: number,
        type: string
      ) {
        let lastActiveIndex = null;
        const nextActiveIndex = type === "increment" ? i + 1 : i - 1;
        const selectableItems =
          selectableRows[nextActiveIndex].getElementsByClassName(
            "selectableItem"
          );
        Array.from(selectableItems).forEach((item: any, lastIndex: number) => {
          if (checkElementHasClass(item, "lastActive")) {
            lastActiveIndex = lastIndex;
          }
        });
        if (lastActiveIndex) {
          selectableItems[lastActiveIndex].classList.add("activeItem");
        } else if (selectableItems.length > 0) {
          selectableItems[0].classList.add("activeItem", "lastActive");
          selectableItems[0].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }

      function __HARD_CODE__scrollInSearchPage(elem, dir) {
        if (location.pathname === "/search") {
          if (dir === "down" && elem.classList.contains("horizontal-list")) {
            document.getElementById("search-page").style.marginTop = "-200px";
          } else {
            document.getElementById("search-page").style.marginTop = "0";
          }
        }
      }

      Array.from(selectableRows).forEach((item: any, i: number) => {
        function handleChangeActiveRow(
          type: string,
          nextRowIndex?: number,
          listType?: string
        ) {
          const statement =
            type === "increment" ? i < selectableRows.length - 1 : i > 0;
          const nextIndex = type === "increment" ? i + 1 : i - 1;
          if (statement) {
            canChangeActiveRow = false;
            if (
              listType !== "pagination" &&
              (nextRowIndex || nextRowIndex === 0)
            ) {
              listContainerELement.style.transitionDuration = ".2s";
              listContainerELement.style.marginTop = `-${
                listType === "tagList"
                  ? nextRowIndex * tagListHeight
                  : nextRowIndex * videoListHeight + (tagListHeight || 0)
              }px`;
            }
            removeActiveItem(item);
            selectableRows[nextIndex].classList.add("activeRow");
            __HARD_CODE__scrollInSearchPage(
              selectableRows[nextIndex],
              direction
            );
            handleSetActiveItemAfterActiveRowChanged(i, type);
          }
        }

        if (checkElementHasClass(item, "activeRow")) {
          const activeItem = item.getElementsByClassName("activeItem");
          const selectableItems = item.getElementsByClassName("selectableItem");
          if (
            (!activeItem || activeItem.length < 1) &&
            selectableItems &&
            selectableItems.length > 0
          ) {
            selectableItems[0].classList.add("activeItem");
          }
          hasActiveRow = true;
          if (direction === "up") {
            if (canChangeActiveRow) {
              if (checkElementHasClass(item, "horizontal-list")) {
                const allItemsTag = _.map(
                  Array.from([...tagLists, ...videoLists]),
                  (item: any) => item.getAttribute("rowid")
                );
                const activeIndex = allItemsTag.indexOf(
                  item.parentNode.parentNode.getAttribute("rowId")
                );
                if (
                  tagLists.length > 0 &&
                  allItemsTag.indexOf(
                    item.parentNode.parentNode.getAttribute("rowId")
                  ) === 0
                ) {
                  handleChangeActiveRow("decrement");
                }
                Array.from(videoLists).forEach((videoRow: any, j: number) => {
                  if (
                    videoRow.getAttribute("rowid") ===
                    item.parentNode.parentNode.getAttribute("rowId")
                  ) {
                    const nextRowIndex = j - 1;
                    if (
                      nextRowIndex === 0 &&
                      interviewHeight &&
                      videoLists &&
                      videoLists.length > 1 &&
                      interviewWrapper
                    ) {
                      interviewWrapper.style.height = interviewHeight;
                      handleChangeActiveRow("decrement", nextRowIndex);
                    } else if (nextRowIndex >= 0 && canChangeActiveRow) {
                      handleChangeActiveRow("decrement", nextRowIndex);
                    } else if (nextRowIndex < 0) {
                      handleChangeActiveRow("decrement");
                    }
                  }
                });
                Array.from(tagLists).forEach((tagRow: any) => {
                  if (
                    activeIndex > 0 &&
                    tagRow.getAttribute("rowid") ===
                      allItemsTag[activeIndex - 1]
                  ) {
                    handleChangeActiveRow("decrement", 0, "tagList");
                  }
                });
              } else {
                handleChangeActiveRow("decrement");
              }
            }
          } else if (direction === "down") {
            if (canChangeActiveRow) {
              if (checkElementHasClass(item, "horizontal-list")) {
                if (videoLists && videoLists.length > 1 && interviewWrapper) {
                  interviewWrapper.style.height = "0px";
                }
                if (videoLists && videoLists.length > 0) {
                  Array.from(videoLists).forEach((videoRow: any, j: number) => {
                    if (
                      videoRow.getAttribute("rowid") ===
                      item.parentNode.parentNode.getAttribute("rowId")
                    ) {
                      const nextRowIndex = j + 1;
                      if (
                        nextRowIndex < videoLists.length &&
                        canChangeActiveRow
                      ) {
                        handleChangeActiveRow(
                          "increment",
                          nextRowIndex,
                          "videoLists"
                        );
                      } else if (paginationWrapper && canChangeActiveRow) {
                        handleChangeActiveRow(
                          "increment",
                          nextRowIndex,
                          "pagination"
                        );
                      }
                    }
                  });
                }
                if (tagLists && tagLists.length > 0) {
                  Array.from(tagLists).forEach((tagRow: any, j: number) => {
                    if (
                      tagRow.getAttribute("rowid") ===
                      item.parentNode.parentNode.getAttribute("rowId")
                    ) {
                      const nextRowIndex = j + 1;
                      if (
                        videoLists &&
                        videoLists.length > 0 &&
                        canChangeActiveRow
                      ) {
                        handleChangeActiveRow(
                          "increment",
                          nextRowIndex,
                          "tagList"
                        );
                      }
                    }
                  });
                }
              } else {
                handleChangeActiveRow("increment");
              }
            }
          }
        }
      });
      if (!hasActiveRow && selectableRows.length > 0) {
        if (selectableRows.length > 1) {
          selectableRows[1].classList.add("activeRow");
        } else {
          selectableRows[0].classList.add("activeRow");
        }
        verticalMove("down");
      }
    }
  };

  // eslint-disable-next-line
  const horizontalMove = (direction): void => {
    let canChangeAtiveItem = true;

    if (selectableRows && selectableRows.length >= 1) {
      function changeActiveItem(
        selectableItems: any,
        element: any,
        index: number,
        type: string
      ) {
        const nextItemIndex = type === "increment" ? index + 1 : index - 1;
        element.classList.remove("lastActive", "activeItem");
        selectableItems[nextItemIndex].classList.add(
          "lastActive",
          "activeItem"
        );

        selectableItems[nextItemIndex].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
        canChangeAtiveItem = false;
      }

      Array.from(selectableRows).forEach((rowItem: any) => {
        if (checkElementHasClass(rowItem, "activeRow")) {
          const selectableItems =
            rowItem.getElementsByClassName("selectableItem");

          Array.from(selectableItems).forEach((item: any, i: number) => {
            if (checkElementHasClass(rowItem, "horizontal-list")) {
              const activeIndex = i - 1;
              if (checkElementHasClass(item, "activeItem")) {
                const rowAppearItems = Math.floor(
                  /* $FlowFixMe */
                  document.getElementById("app").clientWidth /
                    (videoItemWidth + videoItemMarginRight) /
                    2
                );
                if (i > 0 && selectableItems.length - i > rowAppearItems) {
                  // eslint-disable-next-line
                  if (
                    checkElementHasClass(
                      rowItem.parentNode.parentNode,
                      "tagList"
                    )
                  ) {
                    // eslint-disable-next-line
                    rowItem.style.marginRight = `-${
                      direction === "right" && activeIndex === 1
                        ? "0px"
                        : `${
                            (tagItemWidth + tagItemMargin + 2.65) *
                            (direction === "left"
                              ? activeIndex
                              : activeIndex > 1
                              ? activeIndex - 1
                              : activeIndex)
                          }px`
                    }`;
                  } else {
                    // eslint-disable-next-line
                    rowItem.style.marginRight = `-${
                      direction === "right" && activeIndex === 1
                        ? "0px"
                        : `${
                            (videoItemWidth + videoItemMarginRight) *
                            (direction === "left"
                              ? activeIndex + 0.5
                              : activeIndex > 1
                              ? activeIndex - 1
                              : activeIndex)
                          }px`
                    }`;
                  }
                }
              }
            }
            if (
              checkElementHasClass(item, "activeItem") &&
              canChangeAtiveItem
            ) {
              if (direction === "right" && i > 0) {
                changeActiveItem(selectableItems, item, i, "decrement");
              } else if (
                direction === "left" &&
                i < selectableItems.length - 1
              ) {
                changeActiveItem(selectableItems, item, i, "increment");
              }
            }
          });
        }
      });
    }
  };

  return (
    <Styles
      style={{ display: false ? "none" : "block" }}
      backgroundImage={defaultBG}
      upBackgroundImage={upBG}
      rightBackgroundImage={rightBG}
      leftBackgroundImage={leftBG}
      downBackgroundImage={downBG}
      okBackgroundImage={okBG}
    >
      <a className="up" onClick={() => verticalMove("up")} />
      <a className="right" onClick={() => horizontalMove("right")} />
      <a className="down" onClick={() => verticalMove("down")} />
      <a className="left" onClick={() => horizontalMove("left")} />
      <a className="ok" onClick={() => handleClickActiveItem()} />
    </Styles>
  );
};

export default memo(Controls);
